<ng-container *appTranslate="let t">
  @if (isVisible && !dismissed()) {
    <div class="old-ui-countdown-banner" role="banner" aria-live="polite">
      <div class="old-ui-countdown-banner__content">
        <span class="pi pi-clock old-ui-countdown-banner__icon" aria-hidden="true"></span>
        @if (daysRemaining > 0) {
          <span
            [innerHTML]="t('oldUiCountdown.message', { days: daysRemaining, date: OLD_UI_DISABLE_DATE | appDate })"
          ></span>
        } @else {
          <span [innerHTML]="t('oldUiCountdown.messageToday')"></span>
        }
        <a href="javascript:void(0)" class="old-ui-countdown-banner__link" (click)="switchToNewUi()">{{
          t("oldUiCountdown.switchButton")
        }}</a>
      </div>
      <button type="button" class="old-ui-countdown-banner__close" (click)="dismiss()">
        <span class="pi pi-times" aria-hidden="true"></span>
      </button>
    </div>
  }
</ng-container>
